export default {
  title: 'Maintenance Requests',
  description: 'Track and manage maintenance requests from tenants.',
  new_request: 'New Request',
  edit_request: 'Edit Request',
  request_detail: 'Request Detail',

  labels: {
    title: 'Title',
    description: 'Description',
    category: 'Category',
    priority: 'Priority',
    status: 'Status',
    notes: 'Notes',
    unit: 'Unit',
    customer: 'Customer',
    property: 'Property',
    photos: 'Photos',
    photo: 'Photo',
    created_at: 'Submitted',
    completed_at: 'Completed',
    created: 'Submitted',
    completed: 'Completed',
    date: 'Date',
    duration: 'Duration',
    today: 'Today',
    day: 'day',
    days: 'days',
  },

  status: {
    all: 'All',
    open: 'Open',
    in_progress: 'In Progress',
    completed: 'Completed',
  },

  categories: {
    plumbing: 'Plumbing',
    electrical: 'Electrical',
    hvac: 'HVAC / Air Conditioning',
    appliance: 'Appliance',
    structural: 'Structural',
    pest_control: 'Pest Control',
    cleaning: 'Cleaning',
    other: 'Other',
  },

  priority: {
    low: 'Low',
    normal: 'Normal',
    urgent: 'Urgent',
  },

  actions: {
    new_request: 'New Request',
    create_request: 'Create Request',
    update_request: 'Update Request',
    mark_in_progress: 'Mark In Progress',
    mark_completed: 'Mark Completed',
    add_notes: 'Add Notes',
    back_to_list: 'Back to List',
  },

  form: {
    title_new: 'New Maintenance Request',
    title_edit: 'Edit Maintenance Request',
    description_new: 'Create a new maintenance request for a unit.',
    description_edit: 'Update the maintenance request details.',
    select_category: 'Select category',
    select_property: 'Select a property',
    select_unit: 'Select a unit',
    no_customer: 'No specific customer',
    title_placeholder: 'e.g., Leaking faucet in kitchen',
    description_placeholder: 'Describe the issue in detail...',
    category_note: 'Specify details',
    category_note_placeholder: 'e.g., Door lock broken',
  },

  detail: {
    info_title: 'Request Information',
    created_on: 'Created on {{date}}',
  },

  placeholders: {
    title: 'e.g., Leaking faucet in kitchen',
    description: 'Describe the issue in detail...',
    notes: 'Add maintenance notes...',
    select_unit: 'Select a unit',
    select_customer: 'Select a customer',
    select_category: 'Select category',
    select_priority: 'Select priority',
  },

  messages: {
    created: 'Maintenance request created',
    updated: 'Maintenance request updated',
    deleted: 'Maintenance request deleted',
    delete_title: 'Delete Maintenance Request',
    delete_confirm: 'Are you sure you want to delete "{{title}}"?',
    status_updated: 'Status updated to {{status}}',
    error_loading: 'Error loading requests',
    error_description: 'Something went wrong while loading maintenance requests.',
  },

  empty: {
    title: 'No maintenance requests',
    description: 'Maintenance requests from tenants will appear here.',
    not_found: 'Request not found',
  },

  setup_guide: {
    title: 'Get Started with Maintenance',
    description: 'Track and manage maintenance requests from your tenants.',
    prerequisites_title: 'Prerequisites',
    prereq_property: 'At least 1 property with units',
    prereq_setup_property: 'Set up a property',
    step_1_title: 'Set up units',
    step_1_description: 'Create properties and units first',
    step_2_title: 'Create a request',
    step_2_description: 'Log a maintenance request for a unit',
    step_3_title: 'Track status',
    step_3_description: 'Update request status as work progresses',
    prerequisites: {
      units: 'At least 1 property with units',
    },
    steps: {
      create_unit: {
        title: 'Set up units',
        description: 'Create properties and units first',
      },
      create_request: {
        title: 'Create a request',
        description: 'Log a maintenance request for a unit',
      },
      track_status: {
        title: 'Track status',
        description: 'Update request status as work progresses',
      },
    },
  },

  filters: {
    all: 'All',
    all_properties: 'All Properties',
    open: 'Open',
    in_progress: 'In Progress',
    completed: 'Completed',
    date_from: 'From',
    date_to: 'To',
    search_placeholder: 'Search title...',
  },

  errors: {
    validation_failed: 'Validation failed. Please check the form and try again.',

    fields: {
      title: 'Title',
      description: 'Description',
      category: 'Category',
      priority: 'Priority',
      status: 'Status',
      unit_id: 'Unit',
      customer_id: 'Customer',
    },

    codes: {
      blank: "can't be blank",
      taken: 'is already taken',
      invalid: 'is invalid',
      too_short: 'is too short',
      too_long: 'is too long',
      inclusion: 'is not included in the list',
    },
  },
}
